import { Icon } from "@iconify/react"

export function EmptyState({ description = "No hay datos" }) {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-neutral-400">
      <Icon icon="mdi:inbox-outline" className="text-6xl mb-3" />
      <p className="text-sm">{description}</p>
    </div>
  )
}
